import React from 'react'
import { UiCol, UiSingleRow } from "../../../components/grid-container/GridContainer"
import London from "../../../../../styles/img/london-img.jpg"
import { UiButtonPrimary,UiButtonSecondary } from "../../../components/form/UiButton"

import {
    UiPointBreakDownWr,
    UiPointBreakDownCol,
    UiPointBreakDownHr,
    UiPointBreakDownBtnWr
} from "../../../components/common/UiProductElements"
import { useNavigate } from "react-router-dom";

export default function OrderPointSection(props) {

    let navigate = useNavigate();
    const onClick = () => {
        let path = `../../ui/voucher-wallet`; 
        navigate(path);
        
    }

    return (
        <>
            <UiSingleRow>
                <UiCol lg="12" xl="12" className="mb-3">
                    <img src={London} className="img-fluid sb-product-info-img sb-product-info-lg" />
                    <UiPointBreakDownWr>
                        <UiPointBreakDownCol colName="Points Cost" amount="250K Points" />
                        <UiPointBreakDownCol colName="Cash Top Up" amount="£50" />
                        <UiPointBreakDownHr />
                        <UiPointBreakDownCol colName="Points Total" amount="300k Points" />
                        <UiPointBreakDownHr />
                        <h6 className='sb-product-success-heading'>Thanks for ordering. You will receive your experience eCode via email within 24 hours.</h6>
                        <UiPointBreakDownBtnWr>
                            <UiButtonPrimary btnName={`Buy Now ${'250K Points + £50'}`} disabled={false} onClick={onClick}/>
                            <UiButtonPrimary btnName="Or Add to Cart" disabled={true} />
                            <UiButtonSecondary btnName={`View QR CODE`} btnSubName="Click to spend in store" size="48"/>
                            <UiButtonPrimary btnName={`Redeem Online`} />
                            <UiButtonPrimary btnName={`Go to booking page`} />
                            <p>Clicking "redeem" will take you to the vendors website, we accept no liability for third party content…</p>
                        </UiPointBreakDownBtnWr>
                    </UiPointBreakDownWr>
                </UiCol>
            </UiSingleRow>

        </>
    )
}

